import React, { useState, useRef, useEffect } from "react";
import styles from "./ToggleSwitch.module.css";

export default function ToggleSwitch({ options, onChange, value = 0 }) {
    const [activeIndex, setActiveIndex] = useState(value);
    const [bgStyle, setBgStyle] = useState({});
    const btnRefs = useRef([]);

    // 외부 value 변경 시 내부 상태도 동기화
    useEffect(() => {
        setActiveIndex(value);
    }, [value]);

    useEffect(() => {
        const el = btnRefs.current[activeIndex];
        if (!el) return;

        const parentEl = el.parentElement;
        const updatePosition = () => {
            const rect = el.getBoundingClientRect();
            const parentRect = parentEl.getBoundingClientRect();
            setBgStyle({
                width: `${rect.width}px`,
                transform: `translateX(${rect.left - parentRect.left - 4}px)`,
            });
        };

        updatePosition(); // 초기 실행
        const resizeObserver = new ResizeObserver(updatePosition);
        resizeObserver.observe(parentEl);

        return () => resizeObserver.disconnect();
    }, [activeIndex]);



    return (
        <div className={styles.toggleWrapper}>
            <div className={styles.activeBg} style={bgStyle} />
            {options.map((label, idx) => (
                <button
                    key={idx}
                    ref={(el) => (btnRefs.current[idx] = el)}
                    className={`${styles.option} ${activeIndex === idx ? styles.active : ""}`}
                    onClick={() => {
                        setActiveIndex(idx);
                        if (onChange) onChange(options[idx], idx);
                    }}
                >
                    {label}
                </button>
            ))}
        </div>
    );
}
